var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel__header"},[_c('h2',[_c('i',{staticClass:"panel__header__icon icons icon-user"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.profile.title')))])])]),_vm._v(" "),_c('div',{staticClass:"panel__body"},[_c('client-form',{attrs:{"client":_vm.client}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41cea394","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/dashboard/ProfilePanel.vue
// module id = 872
// module chunks = 5